import $ from 'jquery';
import 'slick-carousel';

const activitiesCarousel = () => {
	const el = {
		target: '.mi-carousel__activities',
		parent: '.mi-activities__carouselContainer',
		nav: '.mi-carousel__activitiesNav',
		loopContainer: '.elementor-loop-container',
	};

	let $target = $();

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;

			$target = $(el.target).find(el.loopContainer);
			exec();
		});
	};

	const exec = () => {
		$target.each(function () {
			const $this = $(this);
			$this.find('style').prependTo($this.parent());

			setTimeout(() => {
				$this.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					appendArrows: $this.closest(el.parent).find(el.nav),
					waitForAnimate: true,
					mobileFirst: true,
					responsive: [
						{
							breakpoint: 601,
							settings: {
								slidesToShow: 2,
							},
						},
					],
				});
			}, 50);
		});
	};

	init();
};

try {
	activitiesCarousel();
} catch (error) {
	console.error(error);
}
